export default __webpack_public_path__ + "static/logo-d862457a0ead60b94d39b6dd17af3428.png";